export enum ClaimStatus {
  Draft = 0,
  Queued = 1,
  ValidationErrors = 2,
  NotUploaded = 3,
  Rejected = 4,
  Pended = 5,
  NotRequired = 6,
  PartiallyApproved = 7,
  Cancelled = 8,
  Approved = 9,
  UnderReview = 10,
  AllClaims = 11,
}

export const ClaimStatusLabel: { [key in ClaimStatus]: string } = {
  [ClaimStatus.Queued]: 'PREAUTH.STATUS_TYPE.QUEUED',
  [ClaimStatus.Approved]: 'PREAUTH.STATUS_TYPE.APPROVED',
  [ClaimStatus.PartiallyApproved]: 'PREAUTH.STATUS_TYPE.PARTIALLY_APPROVED',
  [ClaimStatus.Rejected]: 'PREAUTH.STATUS_TYPE.REJECTED',
  [ClaimStatus.Cancelled]: 'PREAUTH.STATUS_TYPE.CANCELLED',
  [ClaimStatus.Pended]: 'PREAUTH.STATUS_TYPE.PENDED',
  [ClaimStatus.NotRequired]: 'PREAUTH.STATUS_TYPE.NOT_REQUIRED',
  [ClaimStatus.ValidationErrors]: 'PREAUTH.STATUS_TYPE.VALIDATION_ERRORS',
  [ClaimStatus.NotUploaded]: 'PREAUTH.STATUS_TYPE.NOT_UPLOADED',
  [ClaimStatus.AllClaims]: 'PREAUTH.STATUS_TYPE.ALL_CLAIMS',
  [ClaimStatus.Draft]: 'PREAUTH.STATUS_TYPE.DRAFT',
  [ClaimStatus.UnderReview]: 'PREAUTH.STATUS_TYPE.UNDER_REVIEW',
};

export const ClaimStatusValue: { [key in ClaimStatus]: string } = {
  [ClaimStatus.Queued]: '55de33c9-7fa3-48ac-99a8-a0bb556f06a2',
  [ClaimStatus.Approved]: 'd2ffd043-5d17-4d7e-b10b-532c54b598f1',
  [ClaimStatus.PartiallyApproved]: '0d18d1e2-2ecb-4d87-823e-5700771622a6',
  [ClaimStatus.Rejected]: 'dceab5d1-f6e3-4dba-b2de-2634cfa6b487',
  [ClaimStatus.Cancelled]: 'b98ed564-91aa-437f-bed5-ced74ca561a2',
  [ClaimStatus.Pended]: '8cfd2c9d-07cb-4993-b712-3817c064ecb8',
  [ClaimStatus.NotRequired]: '387f9f7a-1637-4557-88b2-a05ba81aaaa6',
  [ClaimStatus.ValidationErrors]: '9c544a70-6138-4141-8210-c20c2bef1891',
  [ClaimStatus.NotUploaded]: '92134a70-6138-4241-8210-c20c2bef1891',
  [ClaimStatus.AllClaims]: '00000000-0000-0000-0000-000000000000',
  [ClaimStatus.Draft]: 'a47585b5-5437-48e1-b4eb-314a98f1a52c',
  [ClaimStatus.UnderReview]: '16f16da0-8c44-44a9-9aa3-2b9528f861a6',
};